import { render, staticRenderFns } from "./Upload1.vue?vue&type=template&id=1c1dcc42&scoped=true"
import script from "./Upload1.vue?vue&type=script&lang=js"
export * from "./Upload1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1dcc42",
  null
  
)

export default component.exports